import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { 
  GET_CEREMONIES_PACK, 
  ADD_NEW_CEREMONY_PACK,
  UPDATE_CEREMONY_PACK,
  DELETE_CEREMONY_PACK
 } from "./actionTypes";
import {
  getCeremonies_packSuccess,
  getCeremonies_packFail,
  addCeremony_packSuccess,
  addCeremony_packFail,
  updateCeremony_packSuccess,
  updateCeremony_packFail,
  deleteCeremony_packSuccess,
  deleteCeremony_packFail,
} from "./actions"

//Include Both Helper File wi            th needed methods
import { 
  getCeremonies_pack,
  // getCeremonyProfile,
  addNewCeremony_pack,
  updateCeremony_pack,
  deleteCeremony_pack,
} from "../../helpers/backend_helper";
import { showPopup } from "../popup/actions";

function* fetchCeremonies({payload}) {
  try {
    const response = yield call(getCeremonies_pack,payload);
    yield put(getCeremonies_packSuccess(response));


  } catch (error) {
    yield put(getCeremonies_packFail(error));
      yield put(showPopup({title:error.response.data.message,error:true}));

  }
}

function* onUpdateCeremony ({payload: ceremony }) {
  try {
   let response = yield call(updateCeremony_pack, ceremony);
   if(response.file_src || ceremony.removeImage) ceremony.image = response.file_src
    yield put(updateCeremony_packSuccess(ceremony));
          yield put(showPopup({title:response.message,success:true}));
  } catch (error) {
    yield put(updateCeremony_packFail(error));
      yield put(showPopup({title:error.response.data.message,error:true}));

  }
}

function* onDeleteCeremony({ payload: ceremony }) {
    
  try {
    let response = yield call(deleteCeremony_pack, ceremony);
    yield put(deleteCeremony_packSuccess(ceremony));
          yield put(showPopup({title:response.message,success:true}));

  } catch (error) {
    yield put(deleteCeremony_packFail(error));
      yield put(showPopup({title:error.response.data.message,error:true}));
  }
}

function* onAddNewCeremony({ payload: ceremony }) {
  try {
   let response = yield call(addNewCeremony_pack, ceremony);
    yield put(addCeremony_packSuccess(response.data));
          yield put(showPopup({title:response.message,success:true}));

  } catch (error) {
    yield put(addCeremony_packFail(error));
      yield put(showPopup({title:error.response.data.message,error:true}));

  }
}


// function* fetchCeremonyProfile() {
//   try {
//     const response = yield call(getCeremonyProfile);
//     yield put(getCeremonyProfileSuccess(response));
//   } catch (error) {
//     yield put(getCeremonyProfileFail(error));
//   }
// }

function* ceremonysSaga() {
  yield takeEvery(GET_CEREMONIES_PACK, fetchCeremonies);
  yield takeEvery(ADD_NEW_CEREMONY_PACK, onAddNewCeremony);
  yield takeEvery(UPDATE_CEREMONY_PACK, onUpdateCeremony);
  yield takeEvery(DELETE_CEREMONY_PACK, onDeleteCeremony);
  // yield takeEvery(GET_ADMIN_PROFILE, fetchCeremonyProfile);
}

export default ceremonysSaga;
